import React from 'react';
import { motion } from 'framer-motion';
import { Visualizer } from '@/components/Visualizer';

export function VisualizerArea({
  layoutDimensions,
  isLayoutReady,
  visualizerWidth,
  visualizerHeight,
  isStreamerMode,
  analyserRef,
  dataArrayRef,
  isPlaying,
  visualizerType,
  setVisualizerType,
  currentSong,
  currentTime,
  lyricsPosition,
}) {
  return (
    <div
      className={`relative overflow-hidden flex-1 min-h-0 ${
        isStreamerMode
          ? 'bg-black'
          : 'bg-gradient-to-br from-slate-900/20 to-blue-900/20'
      }`}
      style={{
        height: visualizerHeight,
        minHeight: visualizerHeight,
        maxHeight: visualizerHeight,
        width: visualizerWidth,
        minWidth: visualizerWidth,
        maxWidth: visualizerWidth,
        zIndex: 1,
      }}
    >
      {isLayoutReady && visualizerWidth > 0 && visualizerHeight > 0 ? (
        <motion.div
          // Opacity-only entrance — scale transforms break canvas sizing via
          // getBoundingClientRect and do not trigger ResizeObserver.
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.25 }}
          className="w-full h-full relative"
          style={{
            width: '100%',
            height: '100%',
            zIndex: 1,
          }}
        >
          <Visualizer
            analyser={analyserRef.current}
            dataArray={dataArrayRef.current}
            isPlaying={isPlaying}
            visualizerType={visualizerType}
            onVisualizerChange={setVisualizerType}
            currentSong={currentSong}
            currentTime={currentTime}
            isStreamerMode={isStreamerMode}
            lyricsPosition={lyricsPosition}
            width={visualizerWidth}
            height={visualizerHeight}
          />
        </motion.div>
      ) : (
        <div
          className={`absolute inset-0 flex items-center justify-center transition-all duration-300 ${
            isStreamerMode
              ? 'bg-black'
              : 'bg-gradient-to-br from-slate-900/50 to-blue-900/50'
          }`}
        >
          <div className="text-center text-white">
            <div className="animate-pulse">
              <div className="w-12 h-12 mx-auto mb-4 bg-white/20 rounded-full" />
              <p className="text-lg font-medium">Preparing Visualizer...</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
